// export default class Filter {

/**
 * 格式化时间
 * @param value 时间戳
 * @param type 格式化类型 1 y-m-d | 2 y-d-m h:minute | 3 y-d-m h:minute:second | 4 h:minute:second | 5 h:minute | 6 y年m月d日
 * @param connect 中间连接符号
 * @returns {string}
 */
export const formatDate = (value: any, type: number = 1, connect: string = "-") => {
    if (!value) {
        return "";
    }
    let date = new Date(value);
    let y = getLen(date.getFullYear());
    let m = getLen(date.getMonth() + 1);
    let d = getLen(date.getDate());
    let h = getLen(date.getHours());
    let minute = getLen(date.getMinutes());
    let second = getLen(date.getSeconds());
    let obj: any = {
        "1": `${y}${connect}${m}${connect}${d}`,
        "2": `${y}${connect}${m}${connect}${d} ${h}:${minute}`,
        "3": `${y}${connect}${m}${connect}${d} ${h}:${minute}:${second}`,
        "4": `${h}:${minute}:${second}`,
        "5": `${h}:${minute}`,
        "6": `${y}年${m}月${d}日`
    };
    return obj[type];
};

/**
 * 秒单位转分钟
 * @param value
 * @param type 1 minute分second秒
 */
export const seconds2Date = (value: any, type: number = 1) => {
    if (!value) {
        return "-";
    }
    let seconds = Number(value);
    let min: any = seconds / 60;
    let obj: any = {
        "1": `${parseInt(min)}分${seconds % 60}秒`
    };
    return obj[type];
};

/**
 * 分钟时间格式化
 * @param value
 * @param type 1 xx天xx小时xx分钟
 */
export const formatMinute = (value: any, type: number = 1) => {
    if (!value && value !== 0) {
        return "-";
    }
    let min = Number(value);
    let minute = min % 60;
    let hours = Math.floor(min / 60);
    let day = Math.floor(hours / 24);
    let hour = Math.floor(hours % 24);
    let obj: any = {
        "1": `${day}天${hour}小时${minute}分钟`
    };
    return obj[type];
}

/**
 * 数字补0
 */
export const getLen = (str: any) => {
    return (str + "").length < 2 ? "0" + str : str;
};

/**
 * 超出省略
 */
export const textover = (value: any, num: number = 20) => {
    if (value) {
        return value.length >= num ? `${value.substring(0, num)}...` : value;
    }
};

/**
 * 去除字符串前后空格
 * @param data object
 */
export const stringTrim = (data: any) => {
    Object.keys(data).forEach(key => {
        if (typeof data[key] === "string") {
            data[key] = data[key].trim();
        }
    });
};
// }
